<div
    class="agpr-radio"
    [attr.id]="id ? (id + '_radioContainer') : null"
    [ngClass]="{'agpr-radio--social' : agprStyle === agprComponentStyle.social}"
>
    <div
        class="agpr-radio-srOnly"
    >
        @if (hiddenLabel) {
            <span class="u-srOnly">
                {{ hiddenLabel | localize }}
            </span>
        }
        <!-- For better accessibility, make sure that we use different [name] attributes for different radio groups in the same component -->
        <input
            #rb
            type="radio"
            [attr.id]="id + '_radio'"
            [attr.name]="name"
            [attr.value]="value"
            [checked]="checked"
            (change)="onChange($event)"
            (focus)="onFocus($event)"
            (blur)="onBlur($event)"
            [disabled]="disabled"
            class="u-srOnly"
            tabindex="0"
            [attr.aria-labelledby]="(style === radioTypesEnum.normal &&  label ? id + '_radioLabel ' : '') + ariaLabelledBy"
            [attr.aria-label]="(hiddenLabel ? hiddenLabel : label) | localize"
            [attr.aria-describedby]="(tooltip || iconTooltip ? (id + '_description ') : '') + ariaDescribedBy"
            [agprTooltip]="tooltip || iconTooltip"
            [tooltipPosition]="tooltipPosition"
            [useTooltipAsAriaLabel]="false"
        >
        <span
            *ngIf="tooltip || iconTooltip"
            [id]="id + '_description'"
            class="u-srOnly"
        >
            {{ (tooltip || iconTooltip) | localize }}
        </span>
    </div>
    <!-- The divs/buttons below are for visual/mouse users. Screen readers will not interact with these, but only the ones above -->
    <div
        *ngIf="style === radioTypesEnum.normal || style === radioTypesEnum.social"
        [id]="id + '_radioInput'"
        class="agpr-radio-input agpr-radio-input-normal"
        [ngClass]="{
            'fa-solid fa-circle-dot': checked,
            'fa-regular fa-circle': !checked,
            'fa-duotone': !checked && disabled,
            'agpr-radio-input-normal--focused': focused,
            'agpr-radio-input-normal--disabled': disabled
        }"
        (click)="handleClick($event, rb)"
        aria-hidden="true"
        tabindex="-1"
    >
    </div>

    <button
        *ngIf="style === radioTypesEnum.button"
        [id]="id + '_radioInput'"
        class="agpr-radio-button"
        [ngClass]="{
            'agpr-radio-button--checked': checked,
            'agpr-radio-button--disabled': disabled,
            'agpr-radio-button--focused': focused
        }"
        (click)="handleClick($event, rb)"
        aria-hidden="true"
        tabindex="-1"
        [pTooltip]="iconTooltip | localize"
        [tooltipPosition]="tooltipPosition"
    >
        <span
            *ngIf="icon"
            [ngClass]="{
                'fa-solid': checked && defaultFAIconPrefix,
                'fa-duotone fa-regular': !checked && defaultFAIconPrefix
            }"
            [class]="icon"
        ></span>
        <ng-content select="[customIcon]"></ng-content>
    </button>

    <button
        *ngIf="style === radioTypesEnum.socialNetworks"
        [id]="id + '_radioInput'"
        class="agpr-radio-socialNetwork"
        [pTooltip]="iconTooltip | localize"
        tooltipPosition='top'
        [ngClass]="{
            'agpr-radio-socialNetwork--checked': checked,
            'agpr-radio-socialNetwork--disabled': disabled
        }"
        (click)="handleClick($event, rb)"
        aria-hidden="true"
        tabindex="-1"
    >
        <img
            *ngIf="iconImageUrl"
            [src]="appBaseHref + iconImageUrl"
            [alt]="iconImageAltText | localize"
        />
    </button>

    <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
    @if (style === radioTypesEnum.normal && label) {
        <label
            [for]="id + '_radio'"
            [id]="id + '_radioLabel'"
            class="agpr-radioLabel"
            [ngClass]="{ 'agpr-radioLabel--disabled': disabled }"
            (click)="handleClick($event, rb)"
        >
            <span class="agpr-radioLabel-label">{{ label | localize }}</span>
            <ng-content></ng-content>
        </label>
    }
    <span
        *ngIf="tooltip"
        [id]="id + '_radioInfo'"
        class="fa-regular fa-circle-info agpr-radioInfo"
        [agprTooltip]="tooltip | localize"
        [tooltipPosition]="tooltipPosition"
    ></span>
    <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
</div>
